<template>
    <div class="container-fluid my-3 py-3">
        <div class="row my-3">
            <div class="col-12">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantJournalPosition.name" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                </div>
            </div>                
        </div>
        <div class="row my-3">
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantJournalPosition.linked_component" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("linked_component") }}</label>
                </div>
            </div>   
            <div class="col-6">
                <div class="form-floating">
                    <input id="inputName" ref="name" type="text" name="name" class="form-control"  v-model="plantJournalPosition.linked_component_data_description_data" placeholder="name@example.com">
                    <label for="inputName" class="form-label" >{{ $t("linked_component_data_description_data") }}</label>
                </div>
            </div>               
        </div>
        <div class="text-danger" v-if="errors.length">
            <p v-for="error in errors" v-bind:key="error">{{ error }}</p>
        </div>
        <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'AddPlantJournalPosition',
    emits: ['closeModal'],
    props: {
        organisation: {
            type:Object,
            required: true
        },
        plantSystemHeader: {
            type: Object,
            required: true,
        },
        position: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            plantJournalPosition: {
                name: '',
                linked_component: '',
                linked_component_data_description_data: ''
            },
            errors: [],
        }
    },
    mounted(){
        console.log('entry mounted')
        this.focusInput()
        console.log('exit mounted')
    },
    methods: {
        focusInput() {
            console.log('entry focusInput')
            console.log(this.$refs.name)
            this.$refs.name.focus();
            console.log('exit focusInput')
        },
        submitForm() {
            this.plantJournalPosition.plant_system_journal_header = this.plantSystemHeader.id
            this.plantJournalPosition.created_by = this.$store.state.me.id
            this.plantJournalPosition.modified_by = this.$store.state.me.id
            this.plantJournalPosition.position = this.position
            this.plantJournalPosition.id = 0
            
            axios
                .post(`/api/v1/plant_system_journal_positions/`, this.plantJournalPosition)
                .then(response => {
        
                    createToast({text: this.$t("position added")
                        ,type: 'success'})
                    this.plantJournalPosition.name = ''
                    this.plantJournalPosition.linked_component = ''
                    this.plantJournalPosition.linked_component_data_description_data = ''

                this.$emit('closeModal')
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
        
    }
}
</script>